<template>
  <v-container fluid>
    <app-toolbar
      :dateonefromurl="datesfromURL[0]"
      :datetwofromurl="datesfromURL[1]"
      @datesUpdate="datesUpdate"
    />
    <app-filters
      :filters="filters"
      :selects="reportingData.selects"
      :selectedfromtable="selectedfromtable"
      @filtersUpdate="filtersUpdate"
    />
    <app-charts
      :reporting-data="reportingData.perDay"
      :loading="loading"
      :time-unit="'datetime'"
    />
    <app-per-criteria
      :reporting-data="reportingData.perCriteria"
      :loading="loading"
      :cats="cats"
      @perCriteriaUpdate="perCriteriaUpdate"
    />
  </v-container>
</template>

<script>
  import moment from 'moment'
  import axios from 'axios'
  import Toolbar from '@/components/reporting/toolbar.vue'
  import Filters from '@/components/reporting/filters.vue'
  import Charts from './charts/index.vue'
  import PerCriteria from './perCriterias/index.vue'
  import { mapGetters } from 'vuex'
  export default {
    components: {
      AppFilters: Filters,
      AppToolbar: Toolbar,
      AppCharts: Charts,
      AppPerCriteria: PerCriteria
    },
    data() {
      return {
        loading: false,
        dates: [],
        filters: {
          site: [],
          customer: [],
          auction_type: []
        },
        reportingData: {
          perCriteria: {
            site: [],
            auction_type: [],
            customer: []
          },
          perDay: []
        },
        dataSync: false,
        customerId: 0,
        selectedfromtable: [],
        datesfromURL: []
      }
    },
    computed: {
      ...mapGetters(['appCustomer']),
      cats() {
        return Object.keys(this.reportingData.perCriteria)
      }
    },
    watch: {
      appCustomer() {
        this.filters = Object.assign(
          {},
          {
            site: [],
            auction_type: [],
            customer: []
          }
        )
        this.getDataFromApi()
      }
    },
    created() {
      this.generateFilterFromLink()
    },
    methods: {
      unixDates(dates) {
        return [
          moment(dates[0]).startOf('day').format('x'),
          moment(dates[1])
            .startOf('day')
            .add(1, 'days')
            .subtract(1, 'ms')
            .format('x')
        ]
      },
      datesUpdate(dates) {
        this.dates = this.unixDates(dates)
        this.buildLink(this.filters)
        this.getDataFromApi()
        this.dataSync = true
      },
      async filtersUpdate(foo) {
        this.filters = Object.assign({}, foo)
        this.buildLink(foo)
        if (this.dataSync) await this.getDataFromApi()
        this.dataSync = true
      },
      buildLink(filters) {
        var testDates = this.unixDates([
          moment().startOf('day').subtract(6, 'days'),
          moment().startOf('day').subtract(0, 'days')
        ])
        if (
          filters['auction_type'].length > 0 ||
          filters['site'].length > 0 ||
          filters['customer'].length > 0 ||
          ((testDates[0] != this.dates[0] || testDates[1] != this.dates[1]) &&
            this.dates.length > 0)
        ) {
          var routepath = ''
          if (
            this.$route.path !=
            '/customer-reporting/filters/' + this.appCustomer.id
          ) {
            routepath = 'customer-reporting/filters/' + this.appCustomer.id
          }
          var route = ''

          route = route + '?date0=' + this.dates[0] + '&date1=' + this.dates[1]
          if (filters['auction_type'].length > 0) {
            var auctions = filters['auction_type'].join()
            route = route + '&auction_type=' + auctions
          }

          if (filters['customer'].length > 0) {
            var customers = filters['customer'].join()
            route = route + '&customers=' + customers
            if (filters['site'].length > 0) {
              var sites = filters['site'].join()
              route = route + '&sites=' + sites
            }
          }
          if (this.$route.fullPath != this.$route.path + routepath + route) {
            this.$router.push(routepath + route)
          }
        }
      },
      generateFilterFromLink() {
        if (
          this.$route.path ==
          '/customer-reporting/filters/' + this.appCustomer.id
        ) {
          this.datesfromURL[0] = this.$route.query.date0
          this.datesfromURL[1] = this.$route.query.date1
          if (
            this.$route.query.auction_type != undefined ||
            this.$route.query.sites != undefined ||
            this.$route.query.customers != undefined
          ) {
            var foo = []
            if (this.$route.query.auction_type != undefined) {
              var auctions = this.$route.query.auction_type.split(',')
              foo['auction_type'] = auctions
              this.filters['auction_type'] = foo['auction_type']
            }
            if (this.$route.query.customers != undefined) {
              var customers = this.$route.query.customers.split(',')
              foo['customer'] = customers
              this.filters['customer'] = foo['customer']
            }
            if (this.$route.query.sites != undefined) {
              var sites = this.$route.query.sites.split(',')
              foo['site'] = sites
              this.filters['site'] = foo['site']
            }
          }
        } else {
          if (this.$route.path != '/customer-reporting') {
            this.$router.push({ name: 'customer-reporting' })
          }
        }
        //this.action = 'build'
      },
      perCriteriaUpdate(foo) {
        this.selectedfromtable = foo
        this.filters[foo.category] = [foo.id]
        if (this.dataSync) this.getDataFromApi()
        this.dataSync = true
      },
      getTimeZone() {
        var offset = new Date().getTimezoneOffset(),
          o = Math.abs(offset)
        return (
          (offset < 0 ? '+' : '-') +
          ('00' + Math.floor(o / 60)).slice(-2) +
          ':' +
          ('00' + (o % 60)).slice(-2)
        )
      },
      async getDataFromApi() {
        this.loading = true
        const payload = {
          timeOffset: this.getTimeZone(),
          filters: this.filters,
          dates: this.dates,
          customerId: this.appCustomer.id,
          customers:
            this.filters['customer'].length > 0 ? this.filters['customer'] : []
        }
        try {
          const response = await axios.post(`/api/reporting-total`, payload)
          this.reportingData = response.data
          this.loading = false
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
</script>
